module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Medium.4a96a7a2.woff";